import { createAction } from "@reduxjs/toolkit";

/**
 * Marks an authenticated identity change within the current browser tab.
 *
 * Data fetched or projected for one principal must never remain available to the next principal.
 * The root reducer handles this action by rebuilding all in-memory state from its initial values.
 */
export const principalChanged = createAction("session/principalChanged");

const principalChangeListeners = new Set<() => void>();

/**
 * Work kept outside Redux that belongs to one principal - a queue of saves, say - registers here
 * to be dropped when the principal changes. Resetting the store alone does not reach it.
 * Returns a function that removes the listener.
 */
export function onPrincipalChanged(listener: () => void): () => void {
  principalChangeListeners.add(listener);
  return () => principalChangeListeners.delete(listener);
}

/** Runs every listener registered with {@link onPrincipalChanged}. */
export function notifyPrincipalChangeListeners(): void {
  for (const listener of principalChangeListeners) listener();
}
